import {
  GenericKeyResponseDto,
  SearchKeysResponseDtoEndorsementKeyEntity,
} from '../../api/kmsapiclient'
import { KeyInfo } from '../../components/common/types'
import {
  BaseActionType,
  DELETE_ENDORSEMENT_KEYS_SUCCESS,
  LOAD_ENDORSEMENT_KEYS_SUCCESS,
  LOAD_MORE_ENDORSEMENT_KEYS_SUCCESS,
  UPDATE_ENDORSEMENT_KEYS_SUCCESS,
  UPLOAD_ENDORSEMENT_KEYS_SUCCESS,
} from '../actions/actionTypes'

export const loadEndorsementKeysSuccess = (
  endorsementKeys: SearchKeysResponseDtoEndorsementKeyEntity,
): BaseActionType => ({
  type: LOAD_ENDORSEMENT_KEYS_SUCCESS,
  payload: endorsementKeys,
})

export const loadMoreEndorsementKeysSuccess = (
  endorsementKeys: SearchKeysResponseDtoEndorsementKeyEntity,
): BaseActionType => ({
  type: LOAD_MORE_ENDORSEMENT_KEYS_SUCCESS,
  payload: endorsementKeys,
})

export const updateEndorsementKeySuccess = (
  endorsementKey: GenericKeyResponseDto,
): BaseActionType => ({
  type: UPDATE_ENDORSEMENT_KEYS_SUCCESS,
  payload: endorsementKey,
})

export const deleteEndorsementKeySuccess = (
  endorsementKey: KeyInfo,
): BaseActionType => ({
  type: DELETE_ENDORSEMENT_KEYS_SUCCESS,
  payload: endorsementKey,
})

export const addEndorsementKeySuccess = (
  endorsementKey: GenericKeyResponseDto,
): BaseActionType => ({
  type: UPLOAD_ENDORSEMENT_KEYS_SUCCESS,
  payload: endorsementKey,
})
